module.exports = __webpack_public_path__ + "media/images/country_flags/gr-c2c9aa713f21120a54b36304b37dbcc4.png";